export default "__VITE_ASSET__CTRtLgQY__";